export default {
  open(state, payload) { state.open = payload; return state; },
  phase(state, payload) { state.phase = payload; return state; },
  focus(state, payload) { state.focus = payload; return state; },
  files(state, payload) { state.files = payload; return state; },
  busy(state, payload) { state.busy = payload; return state; },
  progress(state, payload) { state.progress = payload; return state; },
  status(state, payload) { state.status = payload; return state; },
  person(state, payload) { state.person = payload; return state; },
  authEmail(state, payload) { state.authEmail = payload; return state; },
  authBusy(state, payload) { state.authBusy = payload; return state; },
  authStatus(state, payload) { state.authStatus = payload; return state; },
};
